// src/Projects.js
import React, { useState } from "react";
import { Card, Typography, Row, Col, Button, Modal, Image, List } from "antd";
import { GithubOutlined, ShoppingCartOutlined } from "@ant-design/icons";
import { ALL_PROJECTS_DATA } from "../constants";

const { Title, Paragraph } = Typography;

const PortfolioPage = (props) => {
  const { isMobile } = props;
  return (
    <div
      style={{
        paddingTop: isMobile ? 30 : 60,
        paddingBottom: "30px",
        paddingLeft: isMobile ? 0 : 50,
        paddingRight: isMobile ? 0 : 50,
      }}
    >
      <Title level={3}>Portifolio</Title>
      <div style={{ paddingBottom: "30px", fontSize: "16px" }}>
        Welcome to Eljousour Studio's portfolio, a showcase of our proudest
        achievements and a testament to the creativity and expertise we bring to
        every project. Explore a diverse collection of our work, spanning web
        development, mobile app development, desktop apps, and more.
      </div>
      <List
        grid={{
          gutter: 16,
          xs: 1,
          sm: 2,
          md: 2,
          lg: 3,
          xl: 4,
          xxl: 4,
        }}
        dataSource={ALL_PROJECTS_DATA}
        renderItem={(entry, index) => (
          <List.Item>
            <ProjectCard
              key={index}
              title={entry.title}
              period={entry.period}
              description={entry.description}
              image={entry.image}
            />
          </List.Item>
        )}
      />
    </div>
  );
};
const ProjectCard = ({ title, period, description, image }) => {
  const [visible, setVisible] = React.useState(false);
  const [loading, setLoading] = React.useState(true);

  const showModal = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const handleImageLoaded = () => {
    setLoading(false);
  };

  return (
    <Card
      style={{
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
        width: "100%",
      }}
      cover={
        <img
          alt={title}
          src={image}
          style={{ objectFit: "cover", height: "180px" }}
        />
      }
    >
      <div style={{ color: "grey" }}>{period}</div>
      <Title level={4}>{title}</Title>
      <Paragraph ellipsis={{ rows: 2, expandable: false }}>
        {description}
      </Paragraph>
      <Row>
        <Col flex={1}>
          <Button
            type="ghost"
            style={{ borderRadius: "8px", width: "100%" }}
            onClick={showModal}
          >
            Show Details
          </Button>
        </Col>
        <Col>
          <Button
            type="primary"
            style={{ borderRadius: "8px", marginLeft: "8px" }}
            icon={<GithubOutlined />}
            onClick={null}
          />
        </Col>
      </Row>

      <Modal
        title={null}
        visible={visible}
        onCancel={handleCancel}
        footer={null}
        centered
        bodyStyle={{ padding: 0 }}
      >
        <Image
          alt={title}
          src={image}
          style={{ width: "100%", objectFit: "cover" }}
          onLoad={handleImageLoaded}
          loading={loading}
        />
        <div style={{ padding: "20px" }}>
          <Title level={3}>{title}</Title>
          <Title level={5}>{period}</Title>
          <Paragraph>{description}</Paragraph>
          <Button key="back" onClick={handleCancel}>
            Close
          </Button>
        </div>
      </Modal>
    </Card>
  );
};
export default PortfolioPage;
